import React from 'react';
import classNames from 'classnames';

import ArmyListUnitShowV1 from './unit/ArmyListUnitShowV1';
import ArmyListUnitShowV2 from './unit/ArmyListUnitShowV2';
import ArmyListUnitEdit from './unit/ArmyListUnitEdit';
import ArmyListUnitClone from './unit/clone/ArmyListUnitClone';
import ArmyListUnitDelete from './unit/delete/ArmyListUnitDelete';
import ArmyListUnitExport from '../export/mode/ArmyListUnitExport';
import { ArmyListUnitView } from '@Selectors/builder/myArmyList/make/view/ArmyListUnitView';
import ArmyListUnitArsenal from '@Builder/myArmyList/make/ArmyListUnitArsenal';
import { Tooltip } from 'react-tooltip';
import { AppState } from '@Redux/store';
import { ArmyListUnitActionState, ArmyListUnitState } from '@Stores/index';
import { container } from '@Container';
import { TYPES } from '@Types';
import { ArmyListUnitAction } from '@Redux/actions';
import { Nullable } from '@Models';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import Repeater from '@Utils/Repeater';
import { AlertIcon } from './ArmyListUnitComponent.styled';
import ArmyListUnitFavoriteComponent from '@Builder/myArmyList/make/unit/favorite/army-list-unit.favorite.component';
import { checkContraintsPresenter } from '@Selectors/builder/myArmyList/make/validation/check-contraints.presenter';
import ArmyListUnitShowV3 from '@Builder/myArmyList/make/unit/ArmyListUnitShowV3';
import armyListUnitSlice from '@Redux/reducers/builder/armyListUnit.slice';

interface IArmyListUnitProps {
  armyListUnit: ArmyListUnitView;
  showOrganisation: boolean;
}

const ArmyListUnitComponent: React.FC<ArmyListUnitProps> = ({
  armyListUnit,
  showOrganisation,
  actions,
  toogleState,
  isUsed,
  warnings,
  show,
  edit,
  clone,
  toDelete,
  favorite,
  cancel,
}) => {
  return (
    <div
      className={classNames(
        'army_list_unit army_list_unit_overview box-shadow mt-1 ms-0 me-0',
        { 'disabled-unit': !armyListUnit.isEnabled },
      )}
    >
      <div
        className={classNames('row', {
          'disabled-unit': !armyListUnit.isEnabled,
        })}
      >
        <div className="position ui-sortable-handle">{armyListUnit.index}</div>
        <div
          className={classNames('col-12 mt-2 mt-xs-0 ps-4 name', {
            'col-md-7': showOrganisation,
            'col-md-8': !showOrganisation,
          })}
          onClick={() => edit(armyListUnit)}
        >
          <strong>
            {armyListUnit.name}{' '}
            {warnings.length > 0 && (
              <AlertIcon
                className="fa fa-warning"
                data-tooltip-id={armyListUnit.id}
                data-tooltip-place="top"
              ></AlertIcon>
            )}
          </strong>{' '}
          <span className="d-inline d-md-none">
            {armyListUnit.points} pts -{' '}
          </span>
          <Tooltip id={armyListUnit.id} className="tooltip-content">
            <ul>
              <Repeater data={warnings} indexPrefix="warning">
                {(item: any) => <li>{item.message}</li>}
              </Repeater>
            </ul>
          </Tooltip>
          <ArmyListUnitExport
            armyListUnit={armyListUnit.item}
            showPoints={false}
          />
          <ArmyListUnitArsenal armyListUnit={armyListUnit.item} />
        </div>
        <div className="value-points col-4 col-md-1 d-none d-md-block pt-2">
          <strong>{armyListUnit.points}</strong> points
        </div>
        {!isUsed && !actions.requested && (
          <div className="col-12 col-md-3 pt-md-2 text-center">
            <a className="m-1" onClick={() => show(armyListUnit)}>
              <i className="fa-solid fa-magnifying-glass fa-2x"></i>
            </a>
            <a className="m-1" onClick={() => favorite(armyListUnit)}>
              <i className="fa-solid fa-star fa-2x"></i>
            </a>
            <a className="m-1" onClick={() => toogleState(armyListUnit)}>
              <i
                className={classNames('fa fa-2x', {
                  'fa-eye': armyListUnit.isEnabled,
                  'fa-eye-slash': !armyListUnit.isEnabled,
                })}
              />
            </a>
            <a className="m-1" onClick={() => edit(armyListUnit)}>
              <i className="fa fa-edit fa-2x" />
            </a>
            <a className="m-1" onClick={() => clone(armyListUnit)}>
              <i className="fa fa-clone fa-2x" />
            </a>
            <a className="m-1" onClick={() => toDelete(armyListUnit)}>
              <i className="fa fa-trash fa-2x" />
            </a>
          </div>
        )}
        {!isUsed && actions.requested && (
          <div className="col-8 col-md-2 pt-md-2 text-center">
            <a className="m-1" onClick={() => cancel()}>
              <i className="fa-solid fa-3x fa-rectangle-xmark" />
            </a>
          </div>
        )}
      </div>
      {actions.requestShowV1 && (
        <ArmyListUnitShowV1 armyListUnitId={armyListUnit.item.id} />
      )}
      {actions.requestShowV2 && (
        <ArmyListUnitShowV2 armyListUnitId={armyListUnit.item.id} />
      )}
      {actions.requestShowV3 && (
        <ArmyListUnitShowV3 armyListUnitId={armyListUnit.item.id} />
      )}
      {actions.requestEdit && <ArmyListUnitEdit />}
      {actions.requestClone && (
        <ArmyListUnitClone armyListUnit={armyListUnit} />
      )}
      {actions.requestDelete && (
        <ArmyListUnitDelete armyListUnit={armyListUnit} />
      )}
      {actions.requestFavorite && (
        <ArmyListUnitFavoriteComponent armyListUnit={armyListUnit} />
      )}
      {showOrganisation && (
        <div className="tourne red">{armyListUnit.organisationName}</div>
      )}
    </div>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArmyListUnitProps) => ({
  armyListUnit: owsProps.armyListUnit,
  showOrganisation: owsProps.showOrganisation,
  isUsed: false,
  warnings: checkContraintsPresenter(state).filter(
    (message) => message.armyListUnitIds.includes(owsProps.armyListUnit.id),
  ),
  actions: {
    requested: hasAction(state.armyListUnit, owsProps.armyListUnit.id),
    requestShowV1: hasCurrentAction(
      state.armyListUnit,
      ArmyListUnitActionState.ShowV1,
      owsProps.armyListUnit.id,
    ),
    requestShowV2: hasCurrentAction(
      state.armyListUnit,
      ArmyListUnitActionState.ShowV2,
      owsProps.armyListUnit.id,
    ),
    requestShowV3: hasCurrentAction(
      state.armyListUnit,
      ArmyListUnitActionState.ShowV3,
      owsProps.armyListUnit.id,
    ),
    requestEdit: hasCurrentAction(
      state.armyListUnit,
      ArmyListUnitActionState.Edit,
      owsProps.armyListUnit.id,
    ),
    requestClone: hasCurrentAction(
      state.armyListUnit,
      ArmyListUnitActionState.Clone,
      owsProps.armyListUnit.id,
    ),
    requestDelete: hasCurrentAction(
      state.armyListUnit,
      ArmyListUnitActionState.Delete,
      owsProps.armyListUnit.id,
    ),
    requestFavorite: hasCurrentAction(
      state.armyListUnit,
      ArmyListUnitActionState.Favorite,
      owsProps.armyListUnit.id,
    ),
  },
});

const hasAction = (
  armyListUnitState: ArmyListUnitState,
  armyListUnitId: Nullable<string>,
): boolean => {
  return (
    armyListUnitState.action !== null &&
    armyListUnitId != null &&
    armyListUnitId === armyListUnitState.id
  );
};

const hasCurrentAction = (
  armyListUnitState: ArmyListUnitState,
  action: ArmyListUnitActionState,
  armyListUnitId: Nullable<string>,
): boolean => {
  return (
    armyListUnitState.action === action &&
    armyListUnitId != null &&
    armyListUnitId === armyListUnitState.id
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armyListUnitAction = container.get<ArmyListUnitAction>(
    TYPES.Actions.ArmyListUnitAction,
  );
  return {
    toogleState: (armyListUnit: ArmyListUnitView) =>
      dispatch(
        armyListUnitAction.actionToogleEnabledAmyListUnit(
          armyListUnit.item,
          !armyListUnit.isEnabled,
        ),
      ),
    show: (armyListUnit: ArmyListUnitView) =>
      dispatch(
        armyListUnitAction.actionRequestShowArmyListUnit(armyListUnit.item),
      ),
    edit: (armyListUnit: ArmyListUnitView) =>
      dispatch(
        armyListUnitSlice.actions.setRequest({
          armyListUnit: armyListUnit.item,
          action: ArmyListUnitActionState.Edit,
        }),
      ),
    clone: (armyListUnit: ArmyListUnitView) =>
      dispatch(
        armyListUnitSlice.actions.setRequest({
          armyListUnit: armyListUnit.item,
          action: ArmyListUnitActionState.Clone,
        }),
      ),
    toDelete: (armyListUnit: ArmyListUnitView) =>
      dispatch(
        armyListUnitSlice.actions.setRequest({
          armyListUnit: armyListUnit.item,
          action: ArmyListUnitActionState.Delete,
        }),
      ),
    favorite: (armyListUnit: ArmyListUnitView) =>
      dispatch(
        armyListUnitSlice.actions.setRequest({
          armyListUnit: armyListUnit.item,
          action: ArmyListUnitActionState.Favorite,
        }),
      ),
    cancel: () => dispatch(armyListUnitSlice.actions.cancel()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArmyListUnitComponent);

type ArmyListUnitProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
